import { LegalPage } from './LegalPage';

export function PrivacyPage() {
  return (
    <LegalPage
      title="Политика конфиденциальности"
      subtitle="Как lex.ai собирает, использует и защищает персональные данные. Редакция от 21 октября 2026 года."
    >
      <section className="space-y-2">
        <h2 className="text-[19px] font-semibold text-ink">1. Общие положения</h2>
        <p>
          Политика описывает, какие данные получает сервис lex.ai (далее — Сервис), зачем они нужны
          и как долго хранятся. Используя Сервис, вы соглашаетесь с этой Политикой и Условиями
          сервиса.
        </p>
      </section>

      <section className="space-y-2">
        <h2 className="text-[19px] font-semibold text-ink">2. Какие данные мы обрабатываем</h2>
        <ul className="list-disc space-y-1 pl-5">
          <li>
            адрес электронной почты для входа; номер телефона и Telegram ID — как контакты и каналы
            уведомлений, если вы их указали;
          </li>
          <li>имя, фамилия, иные сведения, которые вы указываете в профиле;</li>
          <li>тексты вопросов, сообщений, комментариев и обращений;</li>
          <li>файлы и документы, которые вы загружаете в чат или раздел «Дело»;</li>
          <li>сведения о статусе обращения, оплатах, подписке и возвратах;</li>
          <li>технические данные: IP-адрес, тип устройства и браузера, журналы ошибок, cookie.</li>
        </ul>
        <p>
          Мы просим не загружать документы, содержащие сведения, которые не нужны для вашего
          вопроса: номера банковских карт, пароли, данные третьих лиц без их согласия.
        </p>
      </section>

      <section className="space-y-2">
        <h2 className="text-[19px] font-semibold text-ink">3. Зачем нужны данные</h2>
        <ul className="list-disc space-y-1 pl-5">
          <li>создать аккаунт, подтвердить вход и восстановить доступ;</li>
          <li>передать вопрос юристу и обеспечить переписку по обращению;</li>
          <li>показать статусы, сроки, документы и черновики в кабинете;</li>
          <li>провести оплату, продлить подписку, обработать возврат;</li>
          <li>напомнить о сроке, ответе юриста или окончании тарифа;</li>
          <li>обеспечить безопасность, предотвратить спам и злоупотребления;</li>
          <li>улучшать Сервис по обезличенной статистике.</li>
        </ul>
      </section>

      <section className="space-y-2">
        <h2 className="text-[19px] font-semibold text-ink">4. Правовые основания</h2>
        <p>
          Мы обрабатываем данные на основании вашего согласия, исполнения договора оказания услуг, а
          также требований закона. Для отдельных категорий данных (например, сведений о здоровье) мы
          запрашиваем отдельное согласие.
        </p>
      </section>

      <section className="space-y-2">
        <h2 className="text-[19px] font-semibold text-ink">5. Кому передаются данные</h2>
        <p>
          Доступ к переписке есть у вас и юриста, ведущего обращение. Менеджеры видят данные в
          объёме, необходимом для назначения юриста и контроля сроков. Мы можем привлекать
          подрядчиков для хостинга, отправки писем и SMS, телефонии и платежей — они получают только
          те данные, которые нужны для услуги, и обязаны обеспечить конфиденциальность.
        </p>
        <p>
          Мы не продаём данные и не передаём их третьим лицам для рекламы. Раскрытие возможно по
          законному требованию уполномоченного органа.
        </p>
      </section>

      <section className="space-y-2">
        <h2 className="text-[19px] font-semibold text-ink">6. Cookie и аналитика</h2>
        <p>
          Необходимые cookie обеспечивают вход, безопасность и работу чата. Аналитические cookie
          помогают понять, какие разделы полезны, и не используются для рекламы. Отказаться от
          аналитических cookie можно в баннере при первом визите.
        </p>
      </section>

      <section className="space-y-2">
        <h2 className="text-[19px] font-semibold text-ink">7. Хранение и защита</h2>
        <p>
          Данные хранятся, пока существует аккаунт и пока это необходимо для обращения, бухгалтерии
          и разрешения споров. Переписка и файлы защищены ограничением доступа, шифрованием канала и
          журналированием действий сотрудников. При удалении аккаунта конфиденциальные данные
          удаляются, а обезличенная история обращений может сохраняться для аудита и статистики.
        </p>
      </section>

      <section className="space-y-2">
        <h2 className="text-[19px] font-semibold text-ink">8. Ваши права</h2>
        <ul className="list-disc space-y-1 pl-5">
          <li>получить сведения об обработке ваших данных;</li>
          <li>исправить неточные данные в профиле;</li>
          <li>отозвать согласие и запросить удаление аккаунта;</li>
          <li>отказаться от уведомлений, кроме обязательных сервисных;</li>
          <li>обратиться с жалобой в уполномоченный орган по защите персональных данных.</li>
        </ul>
      </section>

      <section className="space-y-2">
        <h2 className="text-[19px] font-semibold text-ink">9. Контакты</h2>
        <p>
          Вопросы по обработке данных:{' '}
          <a className="font-semibold text-accent" href="mailto:help@lex.ai">
            help@lex.ai
          </a>
          . Мы отвечаем в рабочие дни, как правило, в течение 30 дней.
        </p>
      </section>
    </LegalPage>
  );
}
